export default __webpack_public_path__ + "4807e6f26bbb6fdf9edeedc74997897e.jpg";